import { castMembers } from '@/mocks/cast';
import SectionHeading from './SectionHeading';

const leadCast = castMembers.filter((member) => member.lead);
const supportCast = castMembers.filter((member) => !member.lead);

export default function CastSection() {
  return (
    <section id="cast" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="03 / 演员表"
          title="主要演员与角色关系"
          desc="《蜜桃成熟时》的叙事围绕三位核心人物展开：出走的阿珍、感情不忠的男友 John，以及旅途中相遇的作家 David。以下为主要演员及其角色。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {leadCast.map((member) => (
            <div
              key={member.name}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-xl font-semibold text-background-50">
                  {member.name.slice(0, 1)}
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{member.name}</h3>
                  <p className="mt-0.5 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-900">
                    <i className="ri-user-3-line" />
                    饰 {member.character}
                  </p>
                </div>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">{member.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <div className="flex items-center gap-2">
            <span className="flex items-center justify-center w-6 h-6 text-accent-600">
              <i className="ri-team-line text-lg" />
            </span>
            <h3 className="font-heading text-base font-semibold text-foreground-950">其他参演演员</h3>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {supportCast.map((member) => (
              <span
                key={member.name}
                className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 font-label text-sm text-foreground-800"
              >
                <i className="ri-user-line text-foreground-500" />
                {member.name}
              </span>
            ))}
          </div>
          <p className="mt-4 text-xs leading-relaxed text-foreground-500">
            注：部分演员在片中角色名称未见于公开资料，此处仅列出参演信息。
          </p>
        </div>
      </div>
    </section>
  );
}